import React, { useEffect, useState } from 'react';
import {
  useNavigate,
} from 'react-router-dom';

import authAPI from 'apis/authAPI';
import { getUserDetail } from 'libs/token';

export const useAuth = () => {
  const [userId, setUserId] = useState('');
  const [role, setRole] = useState('');
  const [token, setToken] = useState('');
  
  const navigate = useNavigate();

  const handleLogout = () => {
    setUserId('');
    setRole('');
    setToken('');
    // Store current route before clearing token for expired sessions
    const currentPath = window.location.pathname;
    if (currentPath !== '/signin') {
      localStorage.setItem('redirectAfterLogin', currentPath);
    }
    localStorage.removeItem('token');
    navigate('/signin');
  };

  const checkLoginStatus = async () => {
    const storedToken = localStorage.getItem('token');
    if (!storedToken) {
      handleLogout();
      return;
    }

    try {
      const { data: response } = await authAPI.checkLoginStatus()
      const userDetail = getUserDetail();
      
      if (response && response.isLoggedIn) {
        setUserId(response.userId);
        setRole(userDetail.role);
        setToken(response.accessToken);
        localStorage.setItem('token', response.accessToken);
      } else {
        handleLogout();
      }
    } catch (error) {
      console.error('Not logged in or token expired', error);
      handleLogout();
    }
  };

  useEffect(() => {
    checkLoginStatus();
  }, []);

  return { userId, role, token };
};
